class Pagination {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="Pagination"]'),
      ...options
    };
  }

  init() {
    const { moduleList } = this.config;

    moduleList.forEach(module => {
      Pagination.checkScreenSize(module);
      window.addEventListener('resize', () => Pagination.checkScreenSize(module));
    });
  }

  static checkScreenSize(module) {
    const screenWidth = window.innerWidth || document.body.clientWidth;
    const items = module.querySelectorAll('li');
    const prev = Array.from(items).find(
      item =>
        item.querySelector('a').innerHTML === '&lt;' ||
        item.querySelector('a').innerHTML === module.dataset.prevText
    );

    const next = Array.from(items).find(
      item =>
        item.querySelector('a').innerHTML === '&gt;' ||
        item.querySelector('a').innerHTML === module.dataset.nextText
    );

    if (screenWidth < 768) {
      if (prev) {
        prev.firstChild.innerHTML = '<';
      }

      if (next) {
        next.firstChild.innerHTML = '>';
      }
    } else {
      if (prev) {
        prev.firstChild.innerHTML = module.dataset.prevText;
      }

      if (next) {
        next.firstChild.innerHTML = module.dataset.nextText;
      }
    }
  }
}

export default Pagination;
